namespace SorAraBul.Administration {
    export namespace PurchasePackageFeaturesService {
        export const baseUrl = 'Administration/PurchasePackageFeatures';

        export declare function Create(request: Serenity.SaveRequest<PurchasePackageFeaturesRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PurchasePackageFeaturesRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PurchasePackageFeaturesRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PurchasePackageFeaturesRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Administration/PurchasePackageFeatures/Create",
            Update = "Administration/PurchasePackageFeatures/Update",
            Delete = "Administration/PurchasePackageFeatures/Delete",
            Retrieve = "Administration/PurchasePackageFeatures/Retrieve",
            List = "Administration/PurchasePackageFeatures/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PurchasePackageFeaturesService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
